export default function() {
  return data;
}
let data = {
  zoneOne: "Smart Energy",
  zoneTwo: "Energy Efficiency",
  zoneThree: "Emergency Response",
  zoneFour: "Proactive Transport",
  zoneFive: "Reduce Congestion",
  zoneSix: "Improve Supply Chain",
  zoneSeven: "Proactive Maintenance",
  zoneEight: "Proactive Healthcare",
  zoneNine: "Equipment Tracking",
  zoneTen: "Customer Loyalty",
  zoneEleven: "Smart Ships",
  zoneTwelve: "Smart Surveillance"
};
